angular.module('zc.master.reports', [
  'zc.master'
])





// WEBPACK FOOTER //
// ./src/master_admin_modules/master.reports/index.js.coffee